import {AgendaelementModell, AksjeeierModell, Aksjeeiertype, ArkivMappenodeModell, AvstemningsstatusModell, DokumenterTilSigneringModell, DokumentSignatarerModell, DokumentType, DokumentVersjonModell, EnkelGruppeModell, FemdeltVurdering, GruppeModell, Gruppetype, MedlemsRolleModell, MøteModell, ProtokollDetaljerModell, ProtokollførtMøtedeltakereModell, ProtokollTranskripsjonInformasjonModell, SigneringStatus, SkjermingDetaljerModell, SlettSisteBeholdningsendringModell, Språk, SpørreskjemaModell, SpørreundersøkelseModell, VirussjekkStatus} from "../tjenester/ressurser/generertNg2HttpKlient";
import {skrivZonedDateTimeSerialisert} from "felles-ng2/støttefunksjoner/temporal";
import {Temporal} from "temporal-polyfill";
import {mimetyper} from "felles-ng2/støttefunksjoner/mimetyper";

/*
Samling av metoder som returnerer tomme instanser av våre modeller.
Ved bruk av Signal trengs en initiell verdi for å unngå å måtte deklarere
Signal med typen MODELL_TYPE|null
I slike tilfeller kan tomme-modeller brukes for å unngå null.
 */

export function tomSlettSisteBeholdningsendringModell(): SlettSisteBeholdningsendringModell {
    return {
        sisteInnfoeringsdato: null,
        aksjeklasser: [],
        aksjeeiere: []
    }
}

export function tomAksjeeierModell(): AksjeeierModell {
    return {
        id: '',
        navn: '',
        naavaerendeBeholdning: null,
        foedselsdato: null,
        epost: null,
        type: Aksjeeiertype.person,
        adresse: '',
        organisasjonsnummer: null,
        aksjeeierbokId: '',
        totalBeholdning: 0,
        beholdningshistorikk: [],
        representertAv: null
    }
}

export function tomSkjermingDetaljerModell(): SkjermingDetaljerModell {
    return {
        aarsak: '',
        erSkjermetForKallendeBruker: false,
        harSkjermetForelderForKallendeBruker: false,
        inneholderBarnSkjermetForKallendeBruker: false,
        inneholderSkjermedeBarn: false,
        medlemmerIdUtenTilgangTilForelder: [],
        medlemmerUtenTilgang: [],
        skjermedeMedlemmerId: []
    }
}

export function tomDokumentSignatarerModell(): DokumentSignatarerModell {
    return {
        dagerTilNestePurring: 7,
        dokumentId: '',
        nestePurringSendes: skrivZonedDateTimeSerialisert(Temporal.Now.zonedDateTimeISO()),
        signatarer: [],
        signeringsInvitasjonSendt: null
    }
}

export function tomDokumentVersjonModell(): DokumentVersjonModell {
    return {
        id: '',
        dokumentId: '',
        gruppeId: '',
        forsideBildeId: null,
        aksepterteSignaturmetoder: [],
        antallAnnotasjoner: 0,
        antallSider: null,
        erLestAv: true,
        favoritter: [],
        filnavn: '...',
        filstoerrelse: null,
        foreldre: {arkivdokumentId: null, arkivfilnodeId: null, protokolldokumentId: null, sakId: null},
        harPdfRepresentasjon: false,
        googleDriveUrl: null,
        microsoftOneDriveUrl: null,
        orginalformat: mimetyper.pdf.mimetype,
        pdfFilnavn: null,
        pdfFilstoerrelse: null,
        registreringsdato: skrivZonedDateTimeSerialisert(Temporal.Now.zonedDateTimeISO()),
        registrertAv: null,
        signeringStatus: SigneringStatus.ikkeAktivert,
        skjerming: tomSkjermingModell(),
        type: DokumentType.generiskDokument,
        versjonsnummer: 1,
        virussjekkStatus: VirussjekkStatus.ok
    }
}

export function tomMøteModell(): MøteModell {
    return {
        id: '',
        dato: {start: Temporal.Now.zonedDateTimeISO().toString(), slutt: Temporal.Now.zonedDateTimeISO().toString()},
        laastForRedigering: false,
        detteEllerPaafoelgendeMoeteLaast: false,
        nummer: '...',
        nummerIPlan: 1,
        planId: '',
        tittel: '...',
        behandlingsMaate: '',
        behandlingsSted: '',
        eiendeGruppeId: '',
        erMoetePublisert: false,
        erProtokollPublisert: false,
        formaal: '',
        protokollSigneringStatus: SigneringStatus.ikkeAktivert,
        protokolldokumentId: '',
        appentForStemmegivning: false,
        deltakere: [],
        eksterneDeltakere: [],
        antallIkkeRepresenterteAksjeeiere: null,
        favoritter: [],
        moetevurdering: {antallVurderinger: 0, gjennomsnittligVurdering: FemdeltVurdering.dårligst},
        protokollAksepterteSignaturmetoder: [],
        saker: [],
        tilgang: {erMoetePublisert: false, erProtokollPublisert: false, skjerming: tomSkjermingModell()}
    };
}

export function tomProtokollDetaljerModell(): ProtokollDetaljerModell {
    return {
        dato: {start: Temporal.Now.zonedDateTimeISO().toString(), slutt: Temporal.Now.zonedDateTimeISO().toString()},
        behandlingsMaate: '',
        behandlingsSted: '',
        behandletISakene: [],
        erTilBehandling: false,
        dokumentVersjon: tomDokumentVersjonModell(),
        transkripsjonInformasjon: tomProtokollTranskripsjonInformasjonModell()
    }
}

export function tomProtokollTranskripsjonInformasjonModell(): ProtokollTranskripsjonInformasjonModell {
    return {
        totalVarighet: 'PT0S',
        varighetTranskribert: 'PT0S',
        varighetTranskripsjonFeilet: 'PT0S',
        antallOpptak: 0,
        antallOpptakTranskribert: 0,
        antallOpptakTranskripsjonFeilet: 0,
        oppsummertMoetereferatTilgjengelig: false
    }
}

export function tomProtokollførtMøtedeltakereModell(): ProtokollførtMøtedeltakereModell {
    return {
        moeteId: '',
        deltatte: [],
        forfalte: [],
        ikkeInnkalte: [],
        eksterne: []
    }
}

export function tomEnkelGruppeModell(): EnkelGruppeModell {
    return {
        id: '',
        tittel: '...',
        organisasjonsnavn: '...',
        moetenavn: '...',
        gruppemal: null,
        oppsett: {
            agendaDokumentValg: {utelatteDeler: []},
            forfalteOppgaverDokumentValg: {utelatteForelderTyper: []},
            moeteOgSaksNummerFormat: {moetenummerformat: '', saksnummerformat: ''},
            inkluderAgendaIInnkalling: false,
            aksepterteSignaturmetoder: [],
            skjulSensitivInformasjonIMeldinger: false,
            genereMoetedokumentTosidig: false,
            utelatteMoetedokumentdeler: [],
            moetevurderingAktivert: false,
            sorterSakerEtterSakstype: false,
            spraak: Språk.norsk_bokmål,
            tidssone: 'Europe/Oslo',
            protokollValg: {
                beslutningOrdlydEntall: 'Beslutning',
                beslutningOrdlydFlertall: 'Beslutninger',
            }
        },
        farge: '#cbcbcf',
        gruppetype: Gruppetype.ordinær,
        avtaleId: '',
        logoId: null,
        nedlastningsTidspunkt: null
    };
}

export function tomGruppeModell(): GruppeModell {
    return {
        ...tomEnkelGruppeModell(),
        foreldergruppenavn: null,
        aksjeeierbokId: null,
        harAksjeeierbok: false,
        alleMedlemmer: [],
        medlemmer: [],
        inaktiveMedlemmer: [],
        invitasjoner: [],
        antallMoeterInnevaerendeAar: 0,
        tillatteAutentiseringsmetoder: []
    };
}

export function tomSpørreundersøkelseModell(): SpørreundersøkelseModell {
    return {
        id: '',
        eiendeGruppeId: '',
        tittel: '',
        antallRespondenter: 0,
        erAapenForRespons: false,
        erAvsluttet: true,
        responsperiode: {start: Temporal.Now.zonedDateTimeISO().subtract({days: 1}).toString(), slutt: Temporal.Now.zonedDateTimeISO().add({days: 1}).toString()},
        responsperiodeAntallDager: 1,
        antallRespondenterSvart: 0,
        kallendeBrukersRespondentId: null,
        skjemaId: '',
        skjemaTittel: '',
        skjema: tomtSpørreskjemaModell(),
        respondenter: []
    }
}

export function tomtSpørreskjemaModell(): SpørreskjemaModell {
    return {
        id: '',
        tittel: '',
        beskrivelse: '',
        spoersmaal: []
    }
}

export function tomArkivMappenodeModell(): ArkivMappenodeModell {
    return {
        id: '',
        eiendeGruppeId: '',
        erMappe: true,
        erRotMappe: false,
        forelder: null,
        navn: '',
        barn: [],
        beskrivelse: '',
        skjerming: tomSkjermingModell()
    }
}

export function tomSkjermingModell() {
    return {aarsak: '', erSkjermetForKallendeBruker: false, inneholderBarnSkjermetForKallendeBruker: false, inneholderSkjermedeBarn: false, skjermedeMedlemmerId: []};
}

export function tomAvstemningsstatusModell(): AvstemningsstatusModell {
    return {
        moeteId: '',
        appentForStemmegivning: false,
        antallStemmeberettigedeDeltakere: 0,
        antallAvstemninger: 0,
        antallStemmerAvgittPerDeltaker: {},
        antallDeltakereStemtFerdig: 0,
        antallDeltakereStemtDelvis: 0,
        antallDeltakereStemtIngen: 0,
        antallStemmerAvgittPerAvstemning: {},
        antallAvstemningerStemtFerdig: 0,
        antallAvstemningerStemtDelvis: 0,
        antallAvstemningerStemtIngen: 0
    }
}

export function tomAgendaelementModell(): AgendaelementModell {
    return {
        id: '',
        tittel: '...',
        beskrivelse: '',
        erPause: false,
        indeks: 0,
        nummerIMoete: 1,
        nummer: '...',
        referat: '',
        eiendeGruppeId: '',
        tilgang: {erMoetePublisert: false, erProtokollPublisert: false, skjerming: {aarsak: '', erSkjermetForKallendeBruker: false, inneholderBarnSkjermetForKallendeBruker: false, inneholderSkjermedeBarn: false, skjermedeMedlemmerId: []}},
        moete: {id: '', nummer: '...', nummerIPlan: 1, tittel: '...', dato: {start: Temporal.Now.zonedDateTimeISO().toString(), slutt: Temporal.Now.zonedDateTimeISO().toString()}, laastForRedigering: false, planId: ''},
        avstemninger: [],
        beslutninger: [],
        dokumenter: [],
        oppgaver: [],
        referertFra: [],
        favoritter: [],
        kommentarer: [],
        ansvarlig: null,
        dag: null,
        sakstype: null,
        sp2Ansvarlig: null,
        starttidspunkt: null,
        tema: null,
        varighet: null
    }
}

export function blankMedlemsRolleModell(): MedlemsRolleModell {
    return {
        id: '',
        tittel: '...',
        indeks: 0,
        kanIkkeSlettes: false
    }
}

export function tomDokumenterTilSigneringModell(): DokumenterTilSigneringModell {
    return {
        moeter: [],
        saksdokumenter: [],
        arkivdokumenter: []
    };
}
